import { Body, Col, IconButton, Row } from '@workramp/ui';
import { useTheme } from 'styled-components';
import { I18n } from '~/common/explicit-exports';

type Props = {
  total: number;
  pageSize: number;
  page: number;
  onChangePage: (page: number) => void;
  isNextPageDisabled?: boolean;
  isPreviousPageDisabled?: boolean;
};

export const LearnerPagination = ({
  page = 0,
  total = 0,
  pageSize = 10,
  isNextPageDisabled = false,
  isPreviousPageDisabled = false,
  onChangePage,
}: Props) => {
  const theme = useTheme();
  const start = page * pageSize + 1;
  const end = Math.min(pageSize * (page + 1), total);
  const maxPage = Math.floor(total / pageSize);

  const showingText = I18n.t('js.learner.pagination.showing', {
    range: `${start}–${end}`,
    total,
  });

  const previousLabel = I18n.t('js.learner.pagination.previous');
  const nextLabel = I18n.t('js.learner.pagination.next');

  return (
    <Row>
      <Col>
        <Body level="md" color={theme.colors.on[600]}>
          {showingText}
        </Body>
      </Col>
      <Col xs="auto">
        <IconButton
          onPress={() => onChangePage(Math.max(0, page - 1))}
          iconName="caret-left:regular"
          variant="text"
          color="secondary"
          label={previousLabel}
          isDisabled={isPreviousPageDisabled}
          data-testid="leaner-pagination-previous-button"
        />
        <IconButton
          onPress={() => onChangePage(Math.min(maxPage, page + 1))}
          iconName="caret-right:regular"
          variant="text"
          color="secondary"
          label={nextLabel}
          isDisabled={isNextPageDisabled}
          data-testid="leaner-pagination-next-button"
        />
      </Col>
    </Row>
  );
};
